import React from "react";
import FlatButton from "material-ui/FlatButton";
import { primaryColor, secondaryColor, disabledColor } from "../../theme";
import { pick, omit } from "lodash";
import HelpTooltip from "../../agenda/Cro/components/HelpTooltip";

const Button = ({ helpEnum, helpWidth, tooltipPosition, ...props }) => {
  const mergedStyle = {
    borderRadius: 6,
    height: 36,
    lineHeight: "36px",
    minWidth: 96,
    textTransform: "none",
    fontWeight: 700,
    ...props.style,
  };

  if (helpEnum) {
    return (
      <div
        style={pick(mergedStyle, [
          "margin",
          "marginTop",
          "marginRight",
          "marginBottom",
          "marginLeft",
        ])}
      >
        <HelpTooltip
          helpEnum={helpEnum}
          style={{ width: helpWidth }}
          tooltipPosition={tooltipPosition}
        >
          <FlatButton
            {...props}
            backgroundColor={props.disabled ? disabledColor : primaryColor}
            hoverColor={secondaryColor}
            style={omit(mergedStyle, [
              "margin",
              "marginTop",
              "marginRight",
              "marginBottom",
              "marginLeft",
            ])}
          />
        </HelpTooltip>
      </div>
    );
  }

  return (
    <FlatButton
      {...props}
      backgroundColor={props.disabled ? disabledColor : primaryColor}
      hoverColor={secondaryColor}
      style={mergedStyle}
    />
  );
};

export default Button;
